import { noteSchema } from "src/core/graphql/schema/note.schema";
import { beneficiarySchema } from "./beneficiary.schema";
import { contactSchema } from "./contact.schema";
import { locationSchema } from "./location.schema";

export const userSchema = `
                id
                username
                firstName
                lastName
                middleName
                password
                dateOfBirth
                gender
                registrationDateTime
                createdDateTime
                modifiedDateTime
                lastLoginDateTime
                status
                kyc {
                    idVerificationStatus
                    amlVerificationStatus
                    identificationDocument {
                        documentType
                        documentNumber
                        documentExpiryDate
                        documentIssueDate
                        }
                    addressVerificationStatus
                    response
                    contactedByCustomerService
                    sightedIdDocuments
                    sightedProofOfAddress
                }
                customer {
                    customerType
                }
                notes {
                    ${noteSchema}
                }
                accounts {
                    accountId
                    accountName
                    photo
                    verificationCode
                    transactionPin
                    status
                    beneficiaries {
                        ${beneficiarySchema}
                    }
                    referral {
                        code
                    }
                    contact {
                    ${contactSchema}
                    }
                    type
                    location {
                        ${locationSchema}
                    }
                    
                }
`;
